export enum ImportPlatform {
  GORGIAS = "gorgias",
  ZENDESK = "zendesk",
  REAMAZE = "reamaze",
  RICHPANEL = "richpanel",
}

export enum ImportTab {
  MACROS = "macros",
  TAGS = "tags",
  FAQS = "faqs",
  VIEWS = "views",
  KNOWLEDGE = "knowledge",
}

export interface ImportTabConfig {
  key: ImportTab;
  label: string;
  component: React.ComponentType<{ teamId: string | undefined }>;
}

export interface PlatformConfig {
  id: ImportPlatform;
  displayName: string;
  tabs: ImportTabConfig[];
}
